import { Button, Heading, Layout, Text } from '../../components/core';
import { PageFooter } from '../../components/page';
import { getRoute, useNavigate } from '../../routes';
import { getStylesheet } from '../../styles';
import { Image404Dog } from './Image404Dog';

export const NotFoundPage = (): JSX.Element => {
  const navigate = useNavigate();

  const onPressGoHome = (): void => {
    navigate(getRoute('home', {}));
  };
  const onPressGoToSelfCare = (): void => {
    navigate(getRoute('selfCareHome', {}));
  };

  return (
    <Layout.Flex {...styles.page} testID="onboarding-page">
      <Image404Dog alignSelf="center" size={194} />

      <Layout.VStack {...styles.stack} space={8}>
        <Layout.VStack space={4}>
          <Heading.h6 center>Oops...</Heading.h6>

          <Heading.h2 center>We’re having trouble finding that page.</Heading.h2>

          <Text.para center>
            You might be able to find what you’re looking for in our Self Care library.
          </Text.para>
        </Layout.VStack>

        <Layout.HStack space={4}>
          <Button.secondaryMedium testID="button-not-found-go-to-home" onPress={onPressGoHome}>
            Take me home
          </Button.secondaryMedium>
          <Button.primaryMedium
            testID="button-not-found-go-to-self-care"
            onPress={onPressGoToSelfCare}
          >
            Browse Self Care
          </Button.primaryMedium>
        </Layout.HStack>
      </Layout.VStack>

      <PageFooter />
    </Layout.Flex>
  );
};

const styles = getStylesheet({
  page: {
    height: '100%',
    marginTop: 16,
    position: 'relative',
  },

  stack: {
    alignItems: 'center',
    display: 'flex',
  },
});
